/**
 * GA4 supports up to 5 item_category levels per item:
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */
export const GA4_ITEM_CATEGORY_MAX_LEVELS = 5

export type Ga4ItemCategoryParams = Partial<Record<
  'item_category' | 'item_category2' | 'item_category3' | 'item_category4' | 'item_category5',
  string
>>

/**
 * Build GA4 `item_category`/`item_category2`…`item_category5` parameters from a
 * left-to-right hierarchy of category labels.
 */
export function buildGa4ItemCategoryParams(levels: Array<string | undefined | null>): Ga4ItemCategoryParams {
  const cleaned = levels
    .map(level => (typeof level === 'string' ? level.trim() : ''))
    .filter((level): level is string => level.length > 0)
    .slice(0, GA4_ITEM_CATEGORY_MAX_LEVELS)

  return cleaned.reduce<Ga4ItemCategoryParams>((acc, label, idx) => {
    const key = (idx === 0 ? 'item_category' : `item_category${idx + 1}`) as keyof Ga4ItemCategoryParams
    acc[key] = label
    return acc
  }, {})
}
